import { render } from "./Conteudos.vue?vue&type=template&id=50a7fbf6&scoped=true"
import script from "./Conteudos.vue?vue&type=script&lang=js"
export * from "./Conteudos.vue?vue&type=script&lang=js"

import "./Conteudos.vue?vue&type=style&index=0&id=50a7fbf6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a7fbf6"]])

export default __exports__